import script from "./BuyLessons.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyLessons.vue?vue&type=script&setup=true&lang=js"

import "./BuyLessons.vue?vue&type=style&index=0&id=02b37508&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b37508"]])

export default __exports__